import React from "react";
import PropTypes from "prop-types";

const BiographyComponent = ({
  photo_URL,
  name,
  biography,
  contactInfo: { location, virtual, phone },
}) => {
  return (
    <div className="bg-white shadow-lg rounded-2xl border-2 border-gray-300 p-6 max-w-7xl min-h-fit mx-auto my-10">
      <div className="flex flex-col md:flex-row items-center md:items-start">
        <img
          src={photo_URL || "https://placehold.co/150x150"}
          alt={name}
          className="w-60 h-60 rounded-full shadow-md object-cover mb-4 md:mb-0 md:mr-6"
        />
        <div className="text-center md:text-left">
          <h2 className="text-5xl font-bold text-blue-900 mb-2">{name}</h2>
          <p className="text-gray-600 text-2xl mt-4">{biography}</p>
        </div>
      </div>

      <div className="mt-10">
        <h3 className="text-4xl text-center font-bold text-blue-900  mb-8">
          Informações de Contato
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {/* Presencial */}
          <div>
            <h4 className="text-lg font-semibold text-blue-800">Presencial</h4>
            <p className="text-gray-700 mt-2">{location}</p>
          </div>

          {/* Virtual */}
          <div>
            <h4 className="text-lg font-semibold text-blue-800">Virtual</h4>
            <ul className="text-gray-700 mt-2 space-y-1">
              {virtual.email && (
                <li>
                  Email:{" "}
                  <a
                    href={`mailto:${virtual.email}`}
                    className="text-blue-500 hover:underline"
                  >
                    {virtual.email}
                  </a>
                </li>
              )}
              {virtual.instagram && (
                <li>
                  Instagram:{" "}
                  <a
                    href={`https://instagram.com/${virtual.instagram}`}
                    className="text-blue-500 hover:underline"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    @{virtual.instagram}
                  </a>
                </li>
              )}
            </ul>
          </div>

          {/* Telefone */}
          <div>
            <h4 className="text-lg font-semibold text-blue-800">Telefone</h4>
            <p className="text-gray-700 mt-2">{phone}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

BiographyComponent.propTypes = {
  photo_URL: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  biography: PropTypes.string.isRequired,
  contactInfo: PropTypes.shape({
    location: PropTypes.string.isRequired,
    virtual: PropTypes.shape({
      email: PropTypes.string,
      instagram: PropTypes.string,
    }).isRequired,
    phone: PropTypes.string.isRequired,
  }).isRequired,
};

export default BiographyComponent;
